"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GA4SortingType = void 0;
var GA4SortingType;
(function (GA4SortingType) {
    GA4SortingType["PriceAsc"] = "price_asc";
    GA4SortingType["PriceDesc"] = "price_desc";
    GA4SortingType["DistanceAsc"] = "distance_asc";
    GA4SortingType["RatingDesc"] = "rating_desc";
    GA4SortingType["SalesRankDesc"] = "salesrank_desc";
})(GA4SortingType || (exports.GA4SortingType = GA4SortingType = {}));
//# sourceMappingURL=GA4SortingType.js.map